module.exports = __webpack_public_path__ + "img/announcementGroup.904fc90b.svg";